(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["akna-reviews-trust"] && !Shopify.designMode) return;
  try {
    
  /* Developed by Code Mind */
  if (!customElements.get('akna-reviews-slider')) {
    class AknaReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.viewport ? this.viewport.firstElementChild : null;
        this.bar = this.querySelector('[data-progress]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.viewport || !this.bar) return;

        this.update = this.update.bind(this);
        this.viewport.addEventListener('scroll', this.update, { passive: true });
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));

        this.bindDrag();

        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      step() {
        const card = this.viewport.querySelector('.akna-review-card:not(.akna-review-card--clone)');
        if (!card) return this.viewport.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      go(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollBy({ left: direction * this.step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const vp = this.viewport;
        const max = vp.scrollWidth - vp.clientWidth;
        const visible = vp.scrollWidth > 0 ? (vp.clientWidth / vp.scrollWidth) * 100 : 100;
        const width = Math.max(Math.min(visible, 100), 14);
        const ratio = max > 0 ? vp.scrollLeft / max : 0;

        this.bar.style.width = width + '%';
        this.bar.style.left = ratio * (100 - width) + '%';
        this.classList.toggle('is-static', max <= 2);

        if (this.prev) this.prev.disabled = vp.scrollLeft <= 2;
        if (this.next) this.next.disabled = vp.scrollLeft >= max - 2;
      }

      bindDrag() {
        const vp = this.viewport;
        let startX = 0;
        let startScroll = 0;
        let dragging = false;

        vp.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || getComputedStyle(vp).overflowX !== 'auto') return;
          dragging = true;
          startX = event.clientX;
          startScroll = vp.scrollLeft;
          vp.classList.add('is-dragging');
        });

        window.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          vp.scrollLeft = startScroll - (event.clientX - startX);
        });

        window.addEventListener('pointerup', () => {
          if (!dragging) return;
          dragging = false;
          vp.classList.remove('is-dragging');
        });
      }
    }

    customElements.define('akna-reviews-slider', AknaReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
